export default __webpack_public_path__ + "triangle-arrows-18154a24e305f56335eccf9d6f06cd07.svg";